import { FC } from 'react'

import styled from 'styled-components'

import { Switch } from 'src/Components/Switch'
import { SimpleLabel } from 'src/Components/SimpleLabel'

export interface ScheduleSummaryPrioritizedLaunch {
  startDate: string
  price: string
  isEnabled: boolean
  onChange: (isEnabled: boolean) => void
}

const Container = styled.div<{ $isEnabled: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  width: 100%;
  padding: 8px;
  border-radius: 16px;
  background: ${({ $isEnabled, theme }) =>
    $isEnabled ? theme.color.lightGreen : theme.color.hoverWhite};
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  min-width: 0;
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

const Accent = styled.span`
  color: ${({ theme }) => theme.color.brandGreen};
  font-style: italic;
  font-weight: 700;
`

const Subtitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

export const ScheduleSummaryStartDateRow: FC<
  ScheduleSummaryPrioritizedLaunch
> = ({ price, isEnabled, onChange }) => (
  <Container $isEnabled={isEnabled}>
    <Switch
      checked={isEnabled}
      onChange={onChange}
      aria-label='Priority Launch in 1 hour'
    />
    <TextContainer>
      <Title>
        🚀 Priority Launch in <Accent>1 hour</Accent>
      </Title>
      <Subtitle>Skip the standard 24-48h queue</Subtitle>
    </TextContainer>
    <SimpleLabel color={isEnabled ? 'green' : 'grey'}>{price}</SimpleLabel>
  </Container>
)
